// config/instruments.js
import { ReactComponent as ViolinIcon } from "../assets/violin.svg";
import { ReactComponent as VoiceIcon } from "../assets/voice.svg";
import { ReactComponent as PolyphonicIcon } from "../assets/polyphonic.svg";

export const instrumentButtons = [
  { Icon: ViolinIcon, label: "violin" },
  { Icon: VoiceIcon, label: "voice" },
  { Icon: PolyphonicIcon, label: "polyphonic" },
];
